//export * from './hooks';
import tc from "tinycolor2";

export * from "./style";
export * from "./components";
export * from "./util";
export * from "./hooks";

export { tc as color };
